import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import copy from 'copy-to-clipboard'

import { eplApi } from '@atheneum/api'
import { renderExpertRate } from '@atheneum/api/dist/lib'

import StatusActions from './StatusActions'
import { showDialog, isCancellationError } from '@components/Dialog'
import ShareIcon from '@components/Icon/Share'
import Tooltip from '@components/Tooltip/Tooltip'

class Epl extends Component {
  static propTypes = {
    epl: PropTypes.object,
    modalStore: PropTypes.object,
    projectStore: PropTypes.object,
    growlStore: PropTypes.object,
    staticData: PropTypes.object,
    loggedEvents: PropTypes.object
  }

  displayProfile = () => {
    document.getElementById('expert-quick-search-input').blur()
    this.props.modalStore.show({
      type: 'CLIENT_VIEW_EXPERT_PROFILE',
      props: { epl: this.props.epl }
    })
  }

  renderExpertName = epl => {
    const expert = get(epl, 'epl.expert')
    if (!expert || !expert.fullName) return
    return <div className="epl__expert-name">{expert.fullName}</div>
  }

  getClientViewLink = async e => {
    e.stopPropagation()
    document.getElementById('expert-quick-search-input').blur()
    const { epl, projectStore } = this.props
    try {
      // replace process.env.REACT_APP_CLIENT_AUTH === 'false'
      // with check for project.cascadedSettings
      if(process.env.REACT_APP_CLIENT_AUTH === 'false') {
        const { externLink } = await eplApi.getExternLink(epl.id)

        copy(externLink)
        return showDialog({
          title: 'URL for the EPL has been copied to your clipboard',
          text: externLink,
          type: 'success'
        })
      }

      let externLinks = await eplApi.getExternLinks(epl.id)

      return this.props.modalStore.show({
        type: 'CLIENT_PROJECT_LINK',
        props: {
          externLinks,
          eplId: epl.id,
          hideOkButton: true,
          hideCancelButton: true,
          showCloseIcon: true,
          projectName: projectStore.project.projectName
        }
      })
    } catch (error) {
      return showDialog({
        title: 'Project is closed',
        text: 'You need to open the project to be able to generate the link.',
        type: 'error'
      }).catch(err => isCancellationError(err))
    }
  }

  render() {
    const { epl, staticData, loggedEvents } = this.props
    const experience = epl.relevantExperience
    const position = get(experience, 'position.name', '')
    const positionLocationName = get(experience, 'location', '')

    const counter = loggedEvents.epls[epl.id] || 0

    return (
      <div className="epl">
        <div className="epl__content">
          <Tooltip tooltip={'Copy EPL link to clipboard'} placement="left">
            <div
              className="icons__box pull-right"
              onClick={this.getClientViewLink}>
              <ShareIcon />
            </div>
          </Tooltip>
          {this.renderExpertName(epl)}
          <div className="epl__text-bold">{position}</div>

          <div className="epl__text-group">
            <div className="epl__text-bold epl__text-group-item">
              {epl.formattedExperience}
            </div>
            <div className="epl__location epl__text-group-item">
              {positionLocationName}
            </div>
            <div className="epl__location epl__text-group-item">
              {renderExpertRate(staticData.names, epl.epl)}
            </div>
            <div className="epl__right_segment">
              <div
                className="epl__link  epl__text-group-item"
                onClick={this.displayProfile}>
                View full profile
              </div>
              <div>Profile views: {counter}</div>
            </div>
          </div>
        </div>

        <StatusActions epl={epl.epl} staticData={staticData} />
      </div>
    )
  }
}

export default inject('projectStore', 'growlStore', 'staticData', 'modalStore')(observer(Epl))
